import confirmItemActionAllowed from '../utils/confirmItemActionAllowed';
import getLatestNonDraftItemIdFromConversation from '../utils/getLatestNonDraftItemIdFromConversation';
import { lazyForwardMessage } from 'owa-mail-compose-store';
import * as mailModuleOrchestrator from 'owa-mail-module-orchestrator';
import { ActionSource, InstrumentationContext } from 'owa-mail-store';
import { ClientItemId } from 'owa-client-ids';
import IRMRestrictions from 'owa-mail-store/lib/store/schema/IRMRestrictions';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import { action } from 'satcheljs/lib/legacy';

export default action('forwardConversation')(async function forwardConversation(
    conversationId: ClientItemId,
    actionSource: ActionSource,
    instrumentationContexts: InstrumentationContext[]
) {
    const referenceItemId = await getLatestNonDraftItemIdFromConversation(conversationId);
    if (referenceItemId && referenceItemId.Id) {
        const restrictionToConfirm = <IRMRestrictions>{ ForwardAllowed: true };
        if (
            confirmItemActionAllowed(
                referenceItemId.Id,
                restrictionToConfirm,
                format(strings.irm_actionNotAllowedOnThisConversation, strings.itemHeaderForward)
            )
        ) {
            lazyForwardMessage.importAndExecute(
                referenceItemId,
                actionSource,
                instrumentationContexts
            );
            mailModuleOrchestrator.lazyOnReplyOrReplyAllOrForwardMessage.importAndExecute();
        }
    }
});
